import React from 'react';
import { Box, CircularProgress, Typography, Paper, Stack } from '@mui/material';

interface LoaderProps {
  message?: string;
  fullPage?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ 
  message = 'Loading...', 
  fullPage = false 
}) => {
  const content = (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ p: 4 }}
    >
      <CircularProgress color="primary" size={40} />
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
    </Stack>
  );

  if (fullPage) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 'calc(100vh - 200px)',
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 2, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        my: 2
      }}
    >
      {content}
    </Paper>
  );
};

export default Loader; 